import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

// ---- COMMON MODULES ---- //
import { Functions } from './functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../providers/userdata-model'; 
import { DataExchanger } from '../providers/data-exchanger';
import { GameModel } from '../providers/game-model';
/*
  Generated class for the Login provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Auth {
  errorMessage: string;
  errorMessages: string [] = new Array();
  serverurl: string;

  constructor(public playModel: GameModel, public functions: Functions, public translate: TranslateService, public userdataModel:UserdataModel, public http: Http, public dataExchanger:DataExchanger) {
    this.serverurl=this.functions.getHomeUrl();
  }

  logout(){
    this.errorMessage="";
    this.errorMessages=[];
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      this.getToken().then((response)=>{
          var responseString:string;
          responseString=response.toString();
          if(responseString.indexOf('tokenGot')!=-1){
            var headers = new Headers();
            headers.append('Accept', 'application/json');
            headers.append('X-CSRF-Token', this.userdataModel.getToken());
            // To have this working, added code in xtribe ets_init
            headers.append('Authentication', this.userdataModel.getSession_name()+"="+this.userdataModel.getSessid());
            let options = new RequestOptions({ headers: headers });

            let postParams = {};

            this.http.post(this.serverurl+"/xtribe_api_2/user/logout", postParams, options)
              .subscribe(data => {
                //let obj = JSON.parse(data['_body']);
                this.userdataModel.clearUserdata();
                resolve("LogoutIsOk");
              }, error => {
                console.log("ERROR: "+error);// Error getting the data
                resolve(error);
                this.setErrorMessage("logout",error);
            });
          }else{
             resolve(responseString);
             this.setErrorMessage("logout",responseString);
          }
      });      
    });
  }

  register(username,password,email,fullname,sex,birthDate,education,language){
    this.errorMessage="";
    this.errorMessages=[];
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      //headers.append('Accept', 'application/json');
      headers.append('enctype', 'multipart/form-data');
      let options = new RequestOptions({ headers: headers });

      let formData:FormData = new FormData();
      formData.append("api-key", "1Xtribe.WebServ1");
      formData.append("name", username);
      formData.append("mail", email);
      formData.append("conf_mail", email);
      formData.append("pass", password);
      formData.append("I_agree", "1");
      formData.append("field_fullname[und][0][value]", fullname);
      formData.append("field_sex[und][0]", sex);
      formData.append("field_education[und][0]", education);
      formData.append("field_dob[und][0][value][date]", birthDate ); //"1980-11-04"
      formData.append("language", language ); //"it" or "en"
      // Set language selected among language spoken just for the sake of having this data inside the profile
      if(language=="it"){ formData.append("field_language_sp[und][Italian]", "Italian" ); }
      if(language=="en"){ formData.append("field_language_sp[und][English]", "English" ); }
      
      this.http.post(this.serverurl+"/xtribe_api/user", formData, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.userdataModel.setUserdata(
            obj.guid,"","","","","","","","","",this.functions.language,
            "","","","","","",this.functions.emptyScore,this.functions.emptyLevel,this.functions.emptyNumberOfLogin,
            this.functions.emptyCollectibles,this.functions.emptyBooksinfo,
            this.functions.emptySettingsCurrentGamemode,this.functions.emptySettingsCurrentDifficulty,
            this.functions.language,this.functions.emptySettingsCurrentSoundEffectStatus,
            this.functions.emptySettingsCurrentMusicVolume,this.functions.emptySettingsCurrentCatChosen,
            "","","");
            
          //this.getUserDataFromXtribe();
          resolve("RegisterResIsOk");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("registration",error);
        });
    });
  }

  getUserDataFromXtribe(){
    this.errorMessage="";
    this.errorMessages=[];

    if(this.functions.developMode=="anonymousproduction"){
      return new Promise((resolve) =>{
        let obj = JSON.parse('[{"username":"'+this.functions.generatedGuidForThisSession+'","email":"","fullname":"","picture":"","birthDate":"","sex":"","creationDate":"","education":"","language":"English","spokenLanguages":["English"],"roles":null,"lastAccess":"","lastLogin":"","link":"","cancelLink":"","guid":"'+this.functions.generatedGuidForThisSession+'"}]');
        console.log("+++++getUserDataFromXtribe:"+JSON.stringify(obj));
        var tmpLanguage="en";

        this.userdataModel.setUserdata(
          obj.guid,obj.username,obj.email,"",obj.fullname,
          obj.sex,obj.education,
          obj.birthDate,obj.picture,obj.creationDate,
          tmpLanguage,obj.spokenLanguages,obj.roles,
          obj.lastAccess,obj.lastLogin,obj.link,
          obj.cancelLink,-1,-1,-1,"","","","","",-1,-1,"","","","").then((response)=>{
            resolve("UserDatasIsOk");
          });
      });
    }else{
      return new Promise((resolve) =>{
        if(!this.functions.deviceIsOnline()){
          this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
          resolve("noConnection");
          return;
        }

        var headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('X-CSRF-Token', this.userdataModel.getToken());
        // To have this working, added code in xtribe ets_init
        headers.append('Authentication', this.userdataModel.getSession_name()+"="+this.userdataModel.getSessid());

        let options = new RequestOptions({ headers: headers });
        
        this.http.get(this.serverurl+"/xtribe_api_2/userdata", options)
          .subscribe(data => {
            let obj = JSON.parse(data['_body']);
            //console.log("+++++getUserDataFromXtribe:"+JSON.stringify(obj));
            obj=obj[0];

            var tmpLanguage;
            if (obj.language) { tmpLanguage=obj.language; }else{ tmpLanguage=obj.lingua; }
            if(tmpLanguage=="English"){ tmpLanguage="en"; }
            if(tmpLanguage=="Italian"){ tmpLanguage="it"; }

            this.userdataModel.setUserdata(
              obj.guid,obj.username,obj.email,"",obj.fullname,
              obj.sex,obj.education,
              obj.birthDate,obj.picture,obj.creationDate,
              tmpLanguage,obj.spokenLanguages,obj.roles,
              obj.lastAccess,obj.lastLogin,obj.link,
              obj.cancelLink,-1,-1,-1,"","","","","",-1,-1,"","","","").then((response)=>{
                resolve("UserDatasIsOk");
              });
          }, error => {
            console.log("ERROR: "+error);// Error getting the data
            resolve(error);
            this.setErrorMessage("userdata",error);
          });
      });
    }
  }

  getToken(){
    this.errorMessage="";
    this.errorMessages=[];
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      headers.append('Authentication', this.userdataModel.getSession_name()+"="+this.userdataModel.getSessid());
      let options = new RequestOptions({ headers: headers });
     
      this.http.post(this.serverurl+"/xtribe_api_2/user/token", options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.userdataModel.setUserdata(
            "","","","","","","","","","",
            "","","","","","","",-1,-1,-1,"","",
            "","","",-1,-1,"",obj.token,"","").then((response)=>{
              resolve("tokenGot");
            });  ;
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("gettoken",error);
        });
    });
  }

  /*getLoggedUser(){
    this.errorMessage="";
    this.errorMessages=[];
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      headers.append('X-CSRF-Token', this.userdataModel.getToken());
      headers.append('Authentication', this.userdataModel.getSession_name()+"="+this.userdataModel.getSessid());
      let options = new RequestOptions({ headers: headers });

      this.http.post("http://xtribe.eu:8080/xtribe_api_2/system/connect", options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          resolve("tokenGot");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("gettoken",error);
        });
    });
  }*/

  login(username, password, automatic){
    this.errorMessage="";
    if(this.functions.developMode=="anonymousproduction"){
      return new Promise((resolve) =>{
        let obj = JSON.parse('{"sessid":"anon","session_name":"anon","token":"anon","guid":"'+this.functions.generatedGuidForThisSession+'"}');
        console.log("+++++login:"+JSON.stringify(obj));
        this.playModel.clearGamesData().then((response)=>{
          this.userdataModel.clearUserdata().then((response)=>{
            var usergamedata=[];
            if(!obj.score){ usergamedata[0]=this.functions.emptyScore; }else{ usergamedata[0]=obj.score;}
            if(!obj.level){ usergamedata[1]=this.functions.emptyLevel; }else{ usergamedata[1]=obj.level;}
            if(!obj.numberOfLogin){ usergamedata[9]=this.functions.emptyNumberOfLogin; }else{ usergamedata[9]=obj.numberOfLogin;}

            if(!obj.collectiblesGot){ usergamedata[2]=this.functions.emptyCollectibles; }else{ usergamedata[2]=obj.collectiblesGot;}
            if(!obj.booksinfo){ usergamedata[3]=this.functions.emptyBooksinfo; }else{ usergamedata[3]=obj.booksinfo;}

            if(!obj.settingsCurrentGamemode){ usergamedata[4]=this.functions.emptySettingsCurrentGamemode; }else{ usergamedata[4]=obj.settingsCurrentGamemode;}
            if(!obj.settingsCurrentDifficulty){ usergamedata[5]=this.functions.emptySettingsCurrentDifficulty; }else{ usergamedata[5]=obj.settingsCurrentDifficulty;}
            if(!obj.settingsCurrentLanguage){ usergamedata[6]=this.functions.emptySettingsCurrentLanguage; }else{ usergamedata[6]=obj.settingsCurrentLanguage;}

            if(!obj.settingsCurrentSoundEffectStatus){ usergamedata[7]=this.functions.emptySettingsCurrentSoundEffectStatus; }else{ usergamedata[7]=obj.settingsCurrentSoundEffectStatus;}
            if(!obj.settingsCurrentMusicVolume){ usergamedata[8]=this.functions.emptySettingsCurrentMusicVolume; }else{ usergamedata[8]=obj.settingsCurrentMusicVolume;}
            if(!obj.settingsCurrentCatChosen){ usergamedata[10]=this.functions.emptySettingsCurrentCatChosen; }else{ usergamedata[10]=obj.settingsCurrentCatChosen;}

            console.log("+++++usergamedata:"+JSON.stringify(usergamedata));
        

            this.userdataModel.setUserdata(
              obj.guid,"","","","","","","","","","","","",
              "","","","",usergamedata[0],usergamedata[1],usergamedata[9],usergamedata[2],usergamedata[3],
              usergamedata[4],usergamedata[5],usergamedata[6],usergamedata[7],usergamedata[8],usergamedata[10],
              obj.token,obj.session_name,obj.sessid).then((response)=>{
                this.getUserDataFromXtribe().then((response)=>{
                  this.dataExchanger.getUserGameDataFromServer().then((response)=>{
                    this.dataExchanger.storeUserDataOnServer().then((response)=>{
                      this.dataExchanger.storeUserGamedataOnServer(false);
                    });
                    
                    this.dataExchanger.getGamesDataFromServer().then((response)=>{
                      this.dataExchanger.getGamesrulesDataFromServer().then((response)=>{
                      
                      });
                    });
                  });
                });
            });
          });
        });
        resolve("loginResIsOk");
      });

    }else{
      return new Promise((resolve) =>{
        if(!this.functions.deviceIsOnline()){
          this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
          resolve("noConnection");
          return;
        }

        var headers = new Headers();
        headers.append('Accept', 'application/json');
        //headers.append('X-CSRF-Token', this.userdataModel.getToken());
        //headers.append('Authentication', this.userdataModel.getSession_name()+"="+this.userdataModel.getSessid());

        let options = new RequestOptions({ headers: headers });

        let postParams = {
          "username" : username,
          "password" : password
        }
        
        this.http.post(this.serverurl+"/xtribe_api_2/user/login", postParams, options)
          .subscribe(data => {
            let obj = JSON.parse(data['_body']);

            //console.log("obj: "+JSON.stringify(obj));

            /* --- These operations must be executed in sequence! That's why the promises chain... ---
              1) Login
              2) Clean storage game userdata (Score, level, booksinfo, collectibles) and gamedata (full games json)
              3) Initialize userdata with empty values (score 0, level 1, bookmark and collectibles cleaned)
              4) Store in userdata login data and clean userdata
              5) Ask Xtribe for user profile data
              6) Store in userdata xtribe profile data
              7) Ask rubedo server for game userdata
              8) Store in userdata game userdata if available
              9) Store on server game userdata and user profile data (it can be the first time he joins!)
              9) Ask rubedo server for game data
              10) Store game data locally and in storage
            */
            this.playModel.clearGamesData().then((response)=>{
              this.userdataModel.clearUserdata().then((response)=>{
                var usergamedata=[];
                if(!obj.score){ usergamedata[0]=this.functions.emptyScore; }else{ usergamedata[0]=obj.score;}
                if(!obj.level){ usergamedata[1]=this.functions.emptyLevel; }else{ usergamedata[1]=obj.level;}
                if(!obj.numberOfLogin){ usergamedata[9]=this.functions.emptyNumberOfLogin; }else{ usergamedata[9]=obj.numberOfLogin;}

                if(!obj.collectiblesGot){ usergamedata[2]=this.functions.emptyCollectibles; }else{ usergamedata[2]=obj.collectiblesGot;}
                if(!obj.booksinfo){ usergamedata[3]=this.functions.emptyBooksinfo; }else{ usergamedata[3]=obj.booksinfo;}

                if(!obj.settingsCurrentGamemode){ usergamedata[4]=this.functions.emptySettingsCurrentGamemode; }else{ usergamedata[4]=obj.settingsCurrentGamemode;}
                if(!obj.settingsCurrentDifficulty){ usergamedata[5]=this.functions.emptySettingsCurrentDifficulty; }else{ usergamedata[5]=obj.settingsCurrentDifficulty;}
                if(!obj.settingsCurrentLanguage){ usergamedata[6]=this.functions.emptySettingsCurrentLanguage; }else{ usergamedata[6]=obj.settingsCurrentLanguage;}

                if(!obj.settingsCurrentSoundEffectStatus){ usergamedata[7]=this.functions.emptySettingsCurrentSoundEffectStatus; }else{ usergamedata[7]=obj.settingsCurrentSoundEffectStatus;}
                if(!obj.settingsCurrentMusicVolume){ usergamedata[8]=this.functions.emptySettingsCurrentMusicVolume; }else{ usergamedata[8]=obj.settingsCurrentMusicVolume;}
                if(!obj.settingsCurrentCatChosen){ usergamedata[10]=this.functions.emptySettingsCurrentCatChosen; }else{ usergamedata[10]=obj.settingsCurrentCatChosen;}

                this.userdataModel.setUserdata(
                  obj.guid,"","","","","","","","","","","","",
                  "","","","",usergamedata[0],usergamedata[1],usergamedata[9],usergamedata[2],usergamedata[3],
                  usergamedata[4],usergamedata[5],usergamedata[6],usergamedata[7],usergamedata[8],usergamedata[10],
                  obj.token,obj.session_name,obj.sessid).then((response)=>{
                    this.getUserDataFromXtribe().then((response)=>{
                      this.dataExchanger.getUserGameDataFromServer().then((response)=>{
                        this.dataExchanger.storeUserDataOnServer().then((response)=>{
                          this.dataExchanger.storeUserGamedataOnServer(false);
                        });
                        
                        this.dataExchanger.getGamesDataFromServer().then((response)=>{
                          this.dataExchanger.getGamesrulesDataFromServer().then((response)=>{
                          resolve("loginResIsOk");
                          });
                        });
                      });
                    });
                });
              });
            });
            //this.playModel.getInitialGamesDataFromStorage();
            
          }, error => {
            console.log("ERROR: "+error);// Error getting the data
            resolve(error);
            this.setErrorMessage("registration",error);
          });
      });
    }
  }

  requestNewPassword(usernameoremail){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
     
      //headers.append('X-CSRF-Token', this.userdataModel.getToken());
      //headers.append('Authentication', this.userdataModel.getSession_name()+"="+this.userdataModel.getSessid());

      let options = new RequestOptions({ headers: headers });

      let postParams = {
        "name" : usernameoremail
      }
      
      this.http.post(this.serverurl+"/xtribe_api_2/user/request_new_password", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          console.log("response:"+obj);
          resolve("RequestNewPasswordIsOk");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("requestnewpassword",error);
      });
    });
  }


  //TODO edit profile
  /*
  Ho provato ma non riesco a trovare i parametri giusti per la richiesta. 
  Su postman facendo una put su http://xtribe.eu:8080/xtribe_api_2/user/update
  con header Accept application/json, X-CSRF-Token e valore preso dalla chiamata getToken (dopo aver fatto la chiamata login con l'utente da modificare)
  Content-Type application/x-www-form-urlencoded
  e parametri formato x-www-form-urlencoded
  mail, roles ["1"], field_fullname[und][0][value], field_dob[und][0][value][date], pass e la password
  fa qualcosa ma con due problemi: 
  - se l'utente non è amministratore dice che non ha i permessi
  - quando metto il parametro name mi dice che è già usato (se lo cambio e uso una mail non usata funziona come una registrazione)
  Il problema principale è che il modulo service è vecchio e la documentazione fa schifo quindi per fare questa cosa andrebbe perso tempo a vedere
  l'update che fa dentro il modulo, ma ci vuole un sacco di tempo
  */
  editProfile(username,password,email,fullname,sex,birthDate,education){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      headers.append('Authentication', this.userdataModel.getSession_name()+"="+this.userdataModel.getSessid());

      let options = new RequestOptions({ headers: headers });

      let postParams = {
        "username" : username,
        "password" : password
      }
      
      this.http.post(this.serverurl+"/xtribe_api_2/user/update", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.userdataModel.setUserdata(obj.guid,"","","","","","","","","","","","","","","","",-1,
          this.functions.level,0,"","",
          this.userdataModel.getSettingsCurrentGamemode(),this.userdataModel.getSettingsCurrentDifficulty(),
          this.userdataModel.getSettingsCurrentLanguage(),this.userdataModel.getSettingsCurrentSoundEffectStatus(),
          this.userdataModel.getSettingsCurrentMusicVolume(),this.userdataModel.getSettingsCurrentCatChosen(),obj.token,obj.session_name,obj.sessid);
          this.getUserDataFromXtribe();
          resolve("EditProfileIsOk");
        }, error => {
          console.log("ERROR: "+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("registration",error);
      });
    });
  }

  setErrorMessage(callType, error){
    //console.log("callType: "+callType+" errorORIG: "+error.toString());
    var responseString:string;
    this.errorMessage="";
    responseString=error.toString();
    if(callType=="registration"){
      if(responseString.indexOf('Wrong username or password')!=-1){
        this.translate.get('userPwdWrong').subscribe(value => { this.errorMessage += value+" ";});
      }
      if(responseString.indexOf('is already taken')!=-1){
        this.translate.get('nameTaken').subscribe(value => { this.errorMessage += value+" ";});
      }
      if(responseString.indexOf('is already registered')!=-1){
        this.translate.get('emailTaken').subscribe(value => { this.errorMessage += value+" ";});
      }
      if(this.errorMessage!=""){ return; }
      this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage = value+" ";});
      return;
    }
    if(callType=="login"){
      if(this.errorMessage!=""){ return; }
      this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage = value+" ";});
      return;
    }
    if(callType=="logout"){
      if(responseString.indexOf('User is not logged in')!=-1){
        this.translate.get('userNotLoggedIn').subscribe(value => { this.errorMessage += value+" ";});
        return;
      }
      if(responseString.indexOf('CSRF validation failed')!=-1){
        this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage += value+" ";});
        return;
      }

      if(this.errorMessage!=""){ return; }
      this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage = value+" ";});
      return;
    }
  }
}

/*
[
    {
        "username": "efalivene_plr",
        "email": "e.falivene@ilabroma.com",
        "fullname": "Prova betta",
        "picture": "  <div class=\"user-picture\">\n    <a href=\"/it/users/efaliveneplr\" title=\"Visualizza profilo utente.\"><img typeof=\"foaf:Image\" src=\"http://xtribe.eu:8080/sites/default/files/styles/avatar/public/pictures/picture-16166-1500303787.jpg?itok=sihg_bwk\" width=\"64\" height=\"64\" alt=\"Ritratto di efalivene_plr\" title=\"Ritratto di efalivene_plr\" /></a>  </div>\n",
        "birthDate": {
            "value": "1999-08-12 00:00:00",
            "timezone": "Europe/Rome",
            "timezone_db": "Europe/Rome",
            "date_type": "datetime"
        },
        "sex": "F",
        "creationDate": "2016-10-21 02:00",
        "education": "Primaria",
        "language": "Italian",
        "spokenLanguages": [
            "Italian"
        ],
        "roles": null,
        "lastAccess": "Lunedì, Luglio 17, 2017 - 16:54",
        "lastLogin": "Lunedì, Luglio 17, 2017 - 16:54",
        "link": "<a href=\"/it/users/efaliveneplr\">mostra</a>",
        "cancelLink": "<a href=\"/it/user/16166/cancel?destination=xtribe_api_2/userdata\">annulla</a>",
        "guid": "b38fbe53c5cb1",
        "uid": "16166"
    }
]
*/


// WEBPACK FOOTER //
// ./src/providers/auth.ts